<template>
  <div id="footer">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <h5>Quiero Registrar Mi Marca.com ....</h5>
          <p class="small">
            Copyright © 2020 Todos los derechos reservados.
            <br />
            <!-- <a
              name="terminos"
              id="terminos"
              href=""
              data-toggle="modal"
              data-target=".bd-example-modal-terminos"
              >Términos y condiciones</a
            > -->
            <router-link
              :to="{ name: 'TerminosCondicionesPage' }"
              v-scroll-to="'#terminos'">
              Términos y condiciones
            </router-link>
            |
            <router-link
              :to="{ name: 'AvisoPrivacidadPage' }"
              v-scroll-to="'#aviso-privacidad'">
              Aviso de privacidad
            </router-link>
            <br />
            Desarrollado por
            <a href="https://www.movemini.com/" target="blank">Movemini</a>
          </p>
        </div>
        <div class="col-lg-5">
          <div class="row">
            <div class="col text-right small">
              <router-link
                class="footer-nav"
                v-for="opcion in opcionesMenu"
                :key="opcion.texto"
                :to="'/' + opcion.href"
                v-scroll-to="opcion.href"
              >
                {{ opcion.texto.toUpperCase() }}
              </router-link>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col text-right">
              <a
                class="ml-4"
                :href="redSocial.href"
                target="blank"
                v-for="redSocial in redesSociales"
                :key="redSocial.redSocial"
              >
                <i :class="redSocial.icono"></i>
              </a>
              <a
                class="ml-4"
                href="https://www.tiktok.com/@quieroregistrarmimarca"
                target="blank"
                key="redSocial.tiktok"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-tiktok" viewBox="0 0 16 16" style="margin-top: -16px">
                  <path d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3z"/>
                </svg>
              </a>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainFooter',
  props: ['opcionesMenu', 'redesSociales'],

}
</script>
